<template>
  <div class="transaction">
    <Text
      pattern="body2"
      :weight="500"
      :height="130"
      color="#C18AFD"
      align="left"
    >
      {{ shorten(value) }}
    </Text>
  </div>
</template>

<script>
import { Text } from "@/shared/ui";
import { shorten } from "@/shared/utils/format";
export default {
  name: "Block",
  components: { Text },
  props: {
    value: {
      type: String,
      default: "",
    },
  },

  methods: { shorten },
};
</script>

<style lang="scss" scoped>
.transaction {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
}
</style>
